/**
 * Event Categories Configuration
 *
 * Add new categories here - they'll automatically appear in:
 * - Admin event editor dropdown
 * - Timeline filter buttons
 * - Timeline event styling
 *
 * Each category needs:
 * - id: unique identifier (used in database)
 * - label: display name for admin dropdown
 * - shortLabel: shorter name for timeline filter buttons
 * - color: CSS color for the event (use theme variables when possible)
 * - borderColor: border color for the event
 * - hoverColor: background color on hover
 * - style: optional, 'dashed' for dashed border, 'italic' for italic text
 */

export const CATEGORIES = [
  {
    id: 'campaign',
    label: 'Campaign Milestone',
    shortLabel: 'Campaign',
    color: 'var(--violet-core)',
    borderColor: 'var(--ember-violet)',
    hoverColor: 'var(--ember-violet)',
  },
  {
    id: 'battle',
    label: 'Battle / Critical',
    shortLabel: 'Battle',
    color: 'var(--blood-wine)',
    borderColor: 'var(--rusted-rose)',
    hoverColor: 'var(--rusted-rose)',
  },
  {
    id: 'discovery',
    label: 'Discovery',
    shortLabel: 'Discovery',
    color: '#2A5A7A',
    borderColor: '#4A7A9A',
    hoverColor: '#3A6A8A',
  },
  {
    id: 'political',
    label: 'Political / Covert',
    shortLabel: 'Political',
    color: 'rgba(154, 150, 163, 0.15)',
    borderColor: 'var(--dull-steel)',
    hoverColor: 'rgba(154, 150, 163, 0.3)',
    style: 'dashed',
  },
  {
    id: 'travel',
    label: 'Travel',
    shortLabel: 'Travel',
    color: 'rgba(154, 150, 163, 0.25)',
    borderColor: 'var(--silver-ash)',
    hoverColor: 'rgba(154, 150, 163, 0.4)',
  },
  {
    id: 'world',
    label: 'World Event',
    shortLabel: 'World',
    color: 'var(--success)',
    borderColor: '#5A9A7A',
    hoverColor: '#4A8A6A',
  },
  {
    id: 'personal',
    label: 'Personal / Character',
    shortLabel: 'Personal',
    color: 'var(--ember-violet)',
    borderColor: 'var(--violet-core)',
    hoverColor: '#9A6DFF',
  },
]

// Helper to get category by id
export function getCategory(id) {
  return CATEGORIES.find(c => c.id === id) || CATEGORIES[0]
}

// Helper to get categories as object (for timeline)
export function getCategoriesMap() {
  return Object.fromEntries(
    CATEGORIES.map(c => [c.id, { label: c.shortLabel, color: c.color }])
  )
}
